"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationChargingCommonModel = void 0;
const core = __importStar(require("../../core"));
const LlmCategoryUsage_1 = require("./LlmCategoryUsage");
exports.ConversationChargingCommonModel = core.serialization.object({
    devDiscount: core.serialization.property("dev_discount", core.serialization.boolean().optional()),
    isBurst: core.serialization.property("is_burst", core.serialization.boolean().optional()),
    tier: core.serialization.string().optional(),
    llmUsage: core.serialization.property("llm_usage", LlmCategoryUsage_1.LlmCategoryUsage.optional()),
    llmPrice: core.serialization.property("llm_price", core.serialization.number().optional()),
    llmCharge: core.serialization.property("llm_charge", core.serialization.number().optional()),
    callCharge: core.serialization.property("call_charge", core.serialization.number().optional()),
});
